import { render, staticRenderFns } from "./deviceTestDetail.vue?vue&type=template&id=562a87f8&scoped=true&"
import script from "./deviceTestDetail.vue?vue&type=script&lang=js&"
export * from "./deviceTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./deviceTestDetail.vue?vue&type=style&index=0&id=562a87f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a87f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562a87f8')) {
      api.createRecord('562a87f8', component.options)
    } else {
      api.reload('562a87f8', component.options)
    }
    module.hot.accept("./deviceTestDetail.vue?vue&type=template&id=562a87f8&scoped=true&", function () {
      api.rerender('562a87f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/xiazeng/deviceTestDetail.vue"
export default component.exports